import { ENABLE_DETAILED_SESSION_TRACING_240424 } from "@faire/web-api--source/indigofair/settings/ENABLE_DETAILED_SESSION_TRACING_240424";
import { getSettingValueAndAssign } from "./__internal__/getSetting";
export var getSettingEnableDetailedSessionTracing = function() {
    return getSettingValueAndAssign(ENABLE_DETAILED_SESSION_TRACING_240424, false);
};
